// extracted by mini-css-extract-plugin
export default {"title":"postHeader_title__lRmDW","detail":"postHeader_detail__C9ETk"};